import  { useState, useEffect } from 'react';
// import { CreateButton } from '../../../CommonObjects';
import { CreateTableOld as CreateTable } from '../EmployeeTables/EmployeeTable';
import { base64ToFile } from '../../../../utils/fileUtils';

import { AddUpdateTrainingModal } from '../EmployeeFormFld/TrainingAndSeminarForm';
//icons
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { Button } from '../../../../common/APICommon';

export function TrainingsAndSeminarsTab({
	employeePersonalInformationId,
	employeeTrainingSeminars,
	setEmployeeTrainingSeminars, // This is the state setter for the array
	isEditMode
}) {
	// 1. Array State Management (used only locally/initially)
	const [data, setData] = useState([]);
	useEffect(() => {
		setData(employeeTrainingSeminars);
	}, [employeeTrainingSeminars]);

	// 2. Form State Management (Centralized state for Add/Update Modal)
	const [selectedData, setSelectedData] = useState(null); // Used for Update
	const [selectedIndex, setSelectedIndex] = useState(null); // Used for Update index
	const [title, setTitle] = useState('');
	const [dateFrom, setDateFrom] = useState(null);
	const [dateTo, setDateTo] = useState(null);
	const [file, setFile] = useState([]);
	const [fileName, setFileName] = useState(null);

	// 3. UI/Modal State
	const [showAddForm, setShowAddForm] = useState(false);
	const [showUpdateForm, setShowUpdateForm] = useState(false);

	/** Utility & Modal Handlers --------------------------------------------- */

	const resetAllValues = () => {
		setSelectedData(null);
		setSelectedIndex(null);
		setTitle('');
		setDateFrom(null);
		setDateTo(null);
		setFile(null);
		setFileName(null);
	};

	const openAddForm = () => {
		resetAllValues();
		setShowAddForm(true);
	};
	const closeAddForm = () => setShowAddForm(false);
	const closeUpdateForm = () => setShowUpdateForm(false);

	// Populates state for the update modal before opening it
	const editHandleClick = (_data) => {
		setSelectedData(_data);

		const convertedFile = _data.file ? base64ToFile(_data.file, _data.fileName) : null;

		const index = employeeTrainingSeminars.findIndex(item => item.id === _data.id);

		if (index === -1) {
			console.warn("Item not found in employeeTrainingSeminars by id:", _data.id);
			return;
		}

		setSelectedIndex(index);

		// Pre-populate state for modal
		setTitle(_data.title);
		setDateFrom(_data.dateFrom);
		setDateTo(_data.dateTo);
		setFile(convertedFile || null);
		setFileName(_data.fileName || null);
		setShowUpdateForm(true);
	};

	/** CRUD Logic (Local Array Manipulation) -------------------------------- */

	// Save function for Add (called from AddUpdateModal via onSave)
	const handleAddData = async () => {
		const newData = {
			...selectedData,
			employeePersonalInformationId,
			title,
			dateFrom: dateFrom || null,
			dateTo: dateTo || null,
			file: file || null,
			fileName: fileName || null,
		};

		// Update local array states
		const updatedData = [...employeeTrainingSeminars, newData];
		setData(updatedData);
		setEmployeeTrainingSeminars(updatedData);

		// Reset state after saving (handled by modal's onClose)
	};

	// Save function for Update (called from AddUpdateModal via onSave)
	const handleUpdateData = async () => {
		const newData = {
			...selectedData,
			employeePersonalInformationId,
			title,
			dateFrom: dateFrom || null,
			dateTo: dateTo || null,
			file: file || null,
			fileName: fileName || null,
		};

		// Update local array states at the correct index
		setEmployeeTrainingSeminars(prevValue => {
			const newValue = [...prevValue];
			newValue[selectedIndex] = newData;
			setData(newValue);
			return newValue;
		});
	};

	const deleteHandleClick = (_data) => {
		const index = data.findIndex(item =>
			item.title === _data.title &&
			item.dateFrom === _data.dateFrom &&
			item.dateTo === _data.dateTo &&
			item.file === _data.file &&
			item.fileName === _data.fileName
		);

		if (index === -1) return;

		setEmployeeTrainingSeminars(prevValue => {
			const newValue = [...prevValue];
			newValue.splice(index, 1);
			return newValue;
		});
	};

	/** Table Definition ----------------------------------------------------- */

	const headers = [
		"Title",
		"Date From",
		"Date To",
		"File",
		"",
	];

	const accessors = [
		"title",
		"dateFrom",
		"dateTo",
		"file",
		"manage"
	];

	return (
		<div className="trainings-tab">
			<div className="trainings-tab-top" style={{ display: isEditMode ? "flex" : "none", justifyContent: "start" }}>
				{/* {CreateButton("addEmployee-training-add", "add row", () => openAddForm(), "ADD", GroupAddIcon)} */}
        <Button
          icon={<GroupAddIcon />}
          name={"ADD"}
          className={"bg-green-500 hover:bg-green-600 text-white mb-2"}
          onClick={openAddForm}
        />
			</div>
			<div className="trainings-tab-body">
				<div className="employeesTab-table container">
					<CreateTable
						dataList={data}
						dataHeader={headers}
						dataAccessor={accessors}
						editHandleClick={editHandleClick}
						deleteHandleClick={deleteHandleClick}
						isEditMode={isEditMode}
					/>
					{data.length > 0 ? (
						<div></div>
					)
						:
						(
							<div> {/*<p>No records to display</p>*/}</div>
						)}
				</div>
			</div>

			{/* Add Modal */}
			<AddUpdateTrainingModal
				visible={showAddForm}
				onClose={closeAddForm}
				onSave={handleAddData}
				modalName={"Add Training & Seminar"}
				title={title} setTitle={setTitle}
				dateFrom={dateFrom} setDateFrom={setDateFrom}
				dateTo={dateTo} setDateTo={setDateTo}
				file={file} setFile={setFile}
				fileName={fileName} setFileName={setFileName}
			/>

			{/* Update Modal */}
			<AddUpdateTrainingModal
				visible={showUpdateForm}
				onClose={closeUpdateForm}
				onSave={handleUpdateData}
				modalName={"Edit Training & Seminar"}
				title={title} setTitle={setTitle}
				dateFrom={dateFrom} setDateFrom={setDateFrom}
				dateTo={dateTo} setDateTo={setDateTo}
				file={file} setFile={setFile}
				fileName={fileName} setFileName={setFileName}
			/>
		</div>
	);
}